import React from 'react';
import { CRM_COLORS, PAGE_MAX_WIDTH } from '../theme/crmColors';
import { useIsMobile } from '../hooks/useIsMobile';
import { Box } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import Authentication from '../components/auth/Authentication';
import IntegratedHeader from '../components/header/IntegratedHeader';
import PrestatairesList from '../components/prestataires/PrestatairesList';
import { CustomReducerState } from '../redux/reducers';
import { User } from '../utils/types';
import { prestataires, redirect_to_prestataires } from './paths';

const PrestatairesPage = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();
    const isMobile = useIsMobile();

    return (
        <Authentication redirectTo={redirect_to_prestataires}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        gridTemplateColumns: 'minmax(0, 1fr)',
                        overflowX: 'hidden',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={prestataires}
                        eyebrow={translate('app.headers.eyebrow.reference')}
                        title={translate('app.prestataires.title')}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minWidth: 0,
                            minHeight: 0,
                        }}
                    >
                        <Box
                            style={{
                                width: '100%',
                                maxWidth: PAGE_MAX_WIDTH,
                                margin: '0 auto',
                                padding: isMobile ? 8 : 24,
                                boxSizing: 'border-box',
                            }}
                        >
                            <PrestatairesList />
                        </Box>
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default PrestatairesPage;
